import styled from 'styled-components/macro';

import { Content } from 'common/common.styles';

export const ReceivedContainer = styled(Content)`
  margin-top: -30px;
`;
